import React from 'react';
import DevSignupComp from '../../components/auth/DevSignupComp';

const DevSignup = () => {
  return (
    <div>
        <DevSignupComp />
    </div>
  )
}

export default DevSignup